export class CancellationToken {
  // todo
}
